import { FC, useContext } from "react";
import { StyledCaption, StyledImage } from "./ArticleImage.styled";
import {
  CropObject,
  imageHeroUrl,
  imageHeroUrlPortrait,
} from "common/Utils/images";
import { PublicationContext } from "common/context/Publication";
import { publicationTypes } from "common/context/Publication/PublicationContext";

export interface Props {
  image: {
    url: string;
    caption?: string;
    description?: string;
    credit?: string;
    copyright?: string;
    localCopyright?: string;
    localCaption?: string;
    extra?: {
      sizes?: {
        threebytwo?: CropObject;
        Freeform?: {
          cropData: {
            height: number;
            rotate: number;
            scaleX: number;
            scaleY: number;
            width: number;
            x: number;
            y: number;
          };
          trimData: {
            bottom: number;
            left: number;
            right: number;
            top: number;
          };
        };
      };
    };
    crop?: CropObject;
  };
  type?: string;
  isHeroOverride?: boolean;
  isHero?: boolean;
}

const ArticleImage: FC<Props> = ({
  type,
  image,
  isHeroOverride,
  isHero = false,
}) => {
  const { publication } = useContext<publicationTypes>(PublicationContext);
  const url = image ? image.url : "/images/placeholder.jpg";

  let cropData;
  // Override cropData for Hero article images:
  if (isHero && image?.extra?.sizes?.Freeform) {
    cropData = {
      ...image.extra.sizes.Freeform,
      name: "Freeform",
    } as CropObject;
  } else if (image?.crop && image?.crop?.name) {
    cropData = { ...image.crop, name: image.crop.name } as CropObject;
  } else {
    cropData = {
      ...image?.extra?.sizes?.threebytwo,
      name: "threebytwo",
    } as CropObject;
  }

  const caption = image?.caption;
  const description = image?.description;
  const credit = image?.credit;
  const copyright = image?.copyright;
  const localCopyright = image?.localCopyright;
  const localCaption = image?.localCaption ? image?.localCaption : "";
  const isLocalCaptionHTML =
    localCaption && /<\/?[a-z][\s\S]*>/i.test(localCaption);
  const isCaptionHTML = caption && /<\/?[a-z][\s\S]*>/i.test(caption);

  return (
    <>
      <StyledImage
        image_type={type}
        isHero={isHero}
        srcSet={`
            ${
              isHeroOverride
                ? imageHeroUrlPortrait(publication, url, cropData, true)
                : imageHeroUrl(publication, url, cropData, true)
            }   540w,
            ${
              isHeroOverride
                ? imageHeroUrlPortrait(publication, url, cropData, true)
                : imageHeroUrl(publication, url, cropData, false)
            }   840w,
        `}
        src={
          isHeroOverride
            ? imageHeroUrlPortrait(publication, url, cropData, true)
            : imageHeroUrl(publication, url, cropData)
        }
        alt={description && description}
      />

      <StyledCaption>
        {localCaption ? (
          isLocalCaptionHTML ? (
            <>{localCaption.replace(/<[^>]*>?/gm, "")}</>
          ) : (
            localCaption
          )
        ) : caption && isCaptionHTML ? (
          caption.replace(/<[^>]*>?/gm, "")
        ) : (
          caption
        )}
        <span>
          {credit && <>Credit by ({credit})</>}
          {copyright && <> ({copyright})</>}
          {localCopyright && !copyright && <> ({localCopyright})</>}
        </span>
      </StyledCaption>
    </>
  );
};

export default ArticleImage;
